import type { QueryClient } from "@tanstack/react-query";
import { createRootRouteWithContext, Outlet } from "@tanstack/react-router";
// import { TanStackRouterDevtools } from "@tanstack/react-router-devtools";
import { AppToastViewport } from "~/components/AppToastViewport";
import { InAppNotificationToast } from "~/components/InAppNotificationToast";
import { NativePurchaseBridgeListener } from "~/components/NativePurchaseBridgeListener";
import { Toaster } from "~/components/ui/sonner";

interface RouterContext {
  queryClient: QueryClient;
}

const RootComponent = () => {
  return (
    <>
      <NativePurchaseBridgeListener />
      <Outlet />
      <InAppNotificationToast />
      <AppToastViewport />
      <Toaster />
      {/* <TanStackRouterDevtools /> */}
    </>
  );
};

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootComponent,
});
